import React from 'react'
import { accent, textPrimary, accentLight, statValueStyle } from './styles'
import { formatYear } from './gameLogic'

function EventCard({ event, isAnchor, showYear, wasStrike, revealAnimating }) {
  const getBackgroundColor = () => {
    if (isAnchor) return accentLight
    return 'white'
  }

  const getBorderColor = () => {
    if (isAnchor) return accent
    if (wasStrike === undefined) return accent
    return wasStrike ? '#dc2626' : '#16a34a'
  }

  return (
    <div
      style={{
        padding: '16px',
        backgroundColor: getBackgroundColor(),
        borderRadius: '12px',
        borderLeft: `4px solid ${getBorderColor()}`,
        marginBottom: '12px',
        animation: revealAnimating ? 'revealYear 0.4s ease-out' : 'none',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: '12px' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '0.85rem', fontWeight: '600', color: textPrimary, marginBottom: '4px' }}>{event.title}</div>
          {isAnchor && (
            <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#999' }}>Anchor</div>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {!isAnchor && (wasStrike !== undefined) && (
            <div style={{ fontSize: '1.5rem' }}>
              {wasStrike ? '🔴' : '🟢'}
            </div>
          )}
          {(showYear || isAnchor) && (
            <div
              style={{
                minWidth: '60px',
                textAlign: 'right',
                ...statValueStyle,
                color: accent,
              }}
            >
              {formatYear(event.year)}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default EventCard
